<template>
  <div class="multi-upload" :class="[{'multi-upload-show-in-verify': showInVerify}]">
    <div class="title" v-if="title || tips">
      <span>{{ title }}</span>
      <span v-if="tips" class="tips">{{ tips }}</span>
    </div>
    <div class="img-list" v-if="fileList.length">
      <div v-for="(item, index) in fileList" :key="index" class="avatar" @click="showPreview(item)">
        <img :key="index" :src="item" class="avatar-img" v-if="uploadType === 'image'"/>
        <a :href="item" target="_blank" v-else><i class="el-icon-document text-icon"></i></a>
        <i v-if="!disabled" class="el-icon-close" @click.stop="handleRemove(item)"></i>
      </div>
    </div>
    <div v-else-if="disabled" class="empty-list">暂无</div>
    <el-upload
      v-if="(limit === -1 || fileList.length < limit) && !disabled"
      class="avatar-uploader"
      :accept="acceptTypes[uploadType].join()"
      :disabled="disabled"
      :show-file-list="false"
      :on-success="handleAvatarSuccess"
      :action="'/workspace/manager/portal/upload/' + uploadType"
      name="uploadFile"
      :before-upload="beforeAvatarUpload">
      <i class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <el-image-viewer v-if="dialogVisible" :url-list="fileList" :onClose="() => dialogVisible=false"
        :initialIndex="fileList.indexOf(dialogImageUrl)" :appendToBody="false"></el-image-viewer>
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  components: { ElImageViewer },
  data () {
    return {
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: '',
      acceptTypes: {
        image: ['.jpg', '.jpeg', '.png', '.gif', '.bmp'],
        compress: ['.zip', '.rar'],
        document: ['.doc', '.docx', '.ppt', '.pptx', '.xls', '.xlsx', '.pdf', '.txt'],
        pdf: ['.pdf']
      },
      // 每种文件类型允许上传的最大文件大小(单位：M)
      allowedMaxSize: {
        image: 10,
        compress: 25,
        document: 20,
        pdf: 20
      }
    }
  },
  props: {
    showInVerify: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '上传图片'
    },
    value: {
      type: Array,
      default: () => []
    },
    limit: {
      type: Number,
      default: 2
    },
    tips: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    uploadType: {
      type: String,
      default: 'image'
    }
  },
  methods: {
    handleAvatarSuccess (res) {
      if (res.errorCode === 0) {
        this.fileList.push(res.uploadLink)
        this.$emit('input', this.fileList)
      } else {
        this.$message.error(res.message)
      }
    },
    beforeAvatarUpload (file) {
      if (this.limit !== -1 && this.fileList.length >= this.limit) {
        this.$message.error(`最多只能上传${this.limit}个文件`)
        return false
      }
      let filename = file.name
      let index = filename.lastIndexOf('.')
      if (index > 0) {
        let suffix = filename.substring(index).toLowerCase()
        if (this.uploadType) {
          let acceptType = this.acceptTypes[this.uploadType]
          if (!acceptType) {
            this.$message.error('不支持的上传类型')
            return false
          }
          if (!acceptType.includes(suffix)) {
            this.$message.error('上传的文件格式不合法')
            return false
          }
        }
      } else {
        this.$message.error('上传的文件格式不合法')
        return false
      }
      let allowedMaxSize = this.allowedMaxSize[this.uploadType]
      const isLt2M = file.size / 1024 / 1024 < allowedMaxSize
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 ' + allowedMaxSize + 'MB!')
      }
      return isLt2M
    },
    handleRemove (file) {
      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i] === file) {
          this.fileList.splice(i, 1)
        }
      }
      this.$emit('input', this.fileList)
    },
    showPreview (item) {
      if (this.uploadType === 'image') {
        this.dialogImageUrl = item
        this.$nextTick(() => {
          this.dialogVisible = true
        })
      }
    }
  },
  watch: {
    value: {
      handler (val) {
        this.fileList = val
      },
      immediate: true
    }
  }
}
</script>

<style scoped lang="scss">
.multi-upload {
  margin: 20px;
  display: flex;
  align-items: center;
  & > .title {
    color: #3373B5;
    font-weight: 550;
    font-size: 13px;
    margin-right: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 150px;
    flex-shrink: 0;
    & > .tips {
      color: #999;
      font-size: 12px;
      margin-left: 8px;
    }
  }
  & > .img-list {
    display: flex;
    flex-wrap: wrap;
    & > .avatar {
      width: 150px;
      height: 150px;
      margin-right: 8px;
      margin-bottom: 8px;
      position: relative;
      cursor: pointer;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      & > .avatar-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      & > .el-icon-close {
        position: absolute;
        top: 8px;
        right: 8px;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        cursor: pointer;
      }
      .text-icon {
        width: 150px;
        line-height: 150px;
        text-align: center;
        font-size: 14px;
      }
    }
  }
  & > .empty-list {
    width: 100px;
    display: flex;
    justify-content: center;
    font-size: 12px;
  }
  ::v-deep  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
  .avatar {
    width: 150px;
    height: 150px;
    display: block;
  }
}
.multi-upload-show-in-verify{
  margin: 0;
}
</style>
